var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{class:{'imgSizeMedium':_vm.size=='medium','imgSizeSmall':_vm.size=='small','imgSizeLarge':_vm.size=='large',},attrs:{"src":_vm.src,"alt":_vm.alt}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-634d1bae","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./UI/CoverImg/index.vue
// module id = 715
// module chunks = 0